import { useState } from "react";
import { Box } from "@chakra-ui/react";
import { CraAttribute, CraAttributeType } from "@keita/lanepatrol-sdk";
import { AttributeInput } from "../../shared/views/AttributeInput/AttributeInput";

interface Props {
  attribute: CraAttribute;
  value: any;
  applyChange: (attributeName: string, value: any) => void;
}
export const DemonstratorInput: React.FC<Props> = ({
  attribute,
  value,
  applyChange,
}) => {
  const [newValue, setNewValue] = useState(value);
  return (
    <Box minWidth={36}>
      <AttributeInput
        attribute={attribute}
        value={newValue}
        setValue={(newValue) => {
          setNewValue(newValue);
          applyChange(
            attribute.name,
            standardizeValue(newValue, attribute.type)
          );
        }}
      />
    </Box>
  );
};

const standardizeValue = (value: any, attributeType: CraAttributeType) => {
  switch (attributeType) {
    case CraAttributeType.Number: {
      return parseInt(value) || 0;
    }
    default:
      return value;
  }
};
